import { elasticApi} from '@atheneum/api'
import { extendObservable } from 'mobx'

class ElasticReindexStore {
  constructor () {
    extendObservable(this, { state: null })
  }

  getState = async () => {
    this.state = await elasticApi.getState()
  }

  reindex = async key => {
    await elasticApi.reindex(key)
    await this.getState()
  }

  cancel = async key => {
    await elasticApi.cancel(key)
    await this.getState()
  }

  dropIndex = async key => {
    await elasticApi.dropIndex(key)
    await this.getState()
  }
}

export default ElasticReindexStore
